// extracted by mini-css-extract-plugin
export var posts_contents = "posts-module--posts_contents--36a08";